<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="examDetails" class="w-100">
          <single-exam-question
            v-for="question in examDetails.examQuestions"
            :key="question.examQuestionId"
            :questionDetails="question"
            @getAnswer="setAnswer"
          ></single-exam-question>
          <div class="w-100 d-flex align-items-center justify-content-end">
            <b-button
              :disabled="isSubmitButtonDisabled"
              variant="success"
              @click="createAnswers"
            >
              ثبت آزمون
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  emits: ["getScheduleScores"],
  props: {
    examId: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    this.getAnExam();
  },
  data() {
    return {
      isLoading: false,
      examDetails: null,
      answersDetails: {
        studentUserId: 0,
        masterUserId: 0,
        examId: 0,
        type: 2, // For Special Exam
        answers: [],
      },
      systemScore: 0,
    };
  },
  methods: {
    setAnswer(questionId, answer) {
      let findedQuestion = this.answersDetails.answers.find(
        (answer) => answer.questionId == questionId
      );
      if (findedQuestion) {
        findedQuestion.isCorrect = answer;
      }
    },
    async getAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleExam = new GetASingleExam(_this);
        getASingleExam.setRequestParam({ id: _this.examId });
        await getASingleExam.fetch((response) => {
          if (response.isSuccess) {
            _this.examDetails = response.data;
            _this.examDetails.examQuestions.forEach((item) => {
              _this.answersDetails.answers.push({
                answer: null,
                questionId: item.questionId,
                option: null,
                isCorrect: null,
              });
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createAnswers() {
      this.systemScore = 0;
      try {
        this.answersDetails.studentUserId = this.examDetails.studentUserId;
        this.answersDetails.masterUserId = this.examDetails.masterUserId;
        this.answersDetails.examId = this.examDetails.examId;
        this.isLoading = true;
        let _this = this;
        let createAnswerListForExam = new CreateAnswerListForExam(_this);
        createAnswerListForExam.setRequestParamDataObj(_this.answersDetails);
        await createAnswerListForExam.fetch((response) => {
          if (response.isSuccess) {
            console.log(response.data);
          }
          const eachCorrectQuestionPercentage = Math.ceil(
            100 / _this.answersDetails.answers.length
          );
          _this.answersDetails.answers.forEach((answer) => {
            if (answer.isCorrect == true) {
              _this.systemScore += eachCorrectQuestionPercentage;
            }
          });
          if (_this.systemScore > 100) {
            _this.systemScore = 100;
          }
          _this.calculateExamResult();
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async calculateExamResult() {
      try {
        this.isLoading = true;
        let _this = this;
        let calculateExamResult = new CalculateExamResult(_this);
        calculateExamResult.setRequestParam({
          examId: _this.examId,
          masterUserId: _this.examDetails.masterUserId,
          masterScore: _this.systemScore,
          systemScore: _this.systemScore,
        });
        await calculateExamResult.fetch((response) => {
          if (response.isSuccess) {
            _this.$emit("getScheduleScores");
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (this.answersDetails.answers.length > 0) {
        let isAnyAnswerIsNull = this.answersDetails.answers.some(
          (answer) => answer.isCorrect == null
        );
        return isAnyAnswerIsNull;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    SingleExamQuestion,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetASingleExam } from "@/libs/Api/Exam";
import { CreateAnswerListForExam } from "@/libs/Api/Answer";
import { CalculateExamResult } from "@/libs/Api/Master";
import SingleExamQuestion from "./SingleExamQuestion.vue";
</script>
